



























































import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import _ from "lodash";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Viewpoints from "@/store/modules/Viewpoints";
import { FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import draggable from "vuedraggable";
import ChoiceTableImport from "@/views/ChoiceImport/ChoiceTableImport.vue";
import FactorValueDisplay from "@/components/common/FactorValueDisplay.vue";

const workspaceOptionsModule = getModule(WorkspaceOptions)
const modellingModule = getModule(Modelling)
const viewpointsModule = getModule(Viewpoints)
@Component({
    components: {ConfirmationDialog, FactorValueDisplay, FactorValueInput: ChoiceFactorInput, draggable, ChoiceTableImport}
})
export default class ExportGrowingTable extends Vue {

    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    choiceForm!: any;

    @Prop({default: -1, type: Number})
    selectRow!: number

    private renderKey = 0;

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }


    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }


    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get headers() {
        let headers = this.tableFactorGroup.childrenIds
            .filter(tc => this.isFactorVisible(tc))
            .map(id => {
                return {
                    text: this.factors[id].name,
                    value: id,
                    sortable: false,
                    width: this.getWidth(this.factors[id].type)
                };
            });
        headers.unshift({
            text: " ",
            value: "actions",
            sortable: false,
            width: 25
        })
        return headers;
    }

    get tableData() {
        let dataLengths = this.tableFactorGroup.childrenIds
            .map((id: string) => this.factors[id].dataField || '')
            .map((df: string) => this.choiceForm[df])
            .filter((data: any) => data && Array.isArray(data))
            .map((data: any[]) => data.length)
        let maxDataLength = Math.max(0, ...dataLengths)

        this.tableFactorGroup.childrenIds
            .map((id: string) => this.factors[id].dataField || '')
            .forEach(df => {
                if (maxDataLength > 0 && this.choiceForm[df] == null) {
                    Vue.set(this.choiceForm, df, _.map(new Array(maxDataLength), (el) => {
                        return null
                    }));
                } else if (maxDataLength > 0 && this.choiceForm[df].length < maxDataLength) {
                    this.choiceForm[df].splice(this.choiceForm[df].length, 0, ..._.map(new Array(maxDataLength - this.choiceForm[df].length), () => {
                        return null
                    }))
                }
            })

        return _.map(new Array(maxDataLength), (el, i) => {
            return {
                index: i
            }
        });

    }

    private getWidth(type: string) {
        switch (type) {
            case 'TEXT':
                return 200;
            case 'FILE':
            case 'CATEGORICAL':
                return 160;
        }
        return 140;
    }

    get isFactorListActive() {
        console.log(workspaceOptionsModule.activeFactorLists.length > 0)
        return workspaceOptionsModule.activeFactorLists.length > 0
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    private isFactorVisible(resourceId: string) {
        if(this.showNonListFactors || !this.isFactorListActive) {
        //    return  this.contributingVisibility || (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            return true;
        }
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        }
    }
}
